import React, { useState } from "react";
import { Eye, EyeOff } from "react-feather";
import styles from "./passwordInput.module.css";
import { useTranslation } from "react-i18next";

const PasswordInput = ({
  name = "password",
  className = "",
  hideLabel = false,
  label = "password",
  labelStyles = {},
  inputStyles = {},
  required = true,
  value,
  onChange = null,
}) => {
  const { t } = useTranslation();
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  return (
    <div className={`form-group ${className}`}>
      <label
        className={`form-label ${labelStyles}`}
        style={{ display: hideLabel && "none" }}
      >
        {t(label)}
      </label>
      <div className={styles.inputContainer}>
        <input
          name={name}
          className={`form-control ${styles.input} ${inputStyles}`}
          type={passwordVisible ? "text" : "password"}
          style={{ inputStyles }}
          required={required}
          autoComplete="new-password"
          autoCorrect="off"
          spellCheck={false}
          minLength={8}
          maxLength={16}
          value={value}
          onChange={onChange}
        />
        {value && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className={styles.showPasswordBtn}
          >
            {passwordVisible ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        )}
      </div>
    </div>
  );
};

export default PasswordInput;
